<template>
  <v-breadcrumbs :items="breadcrumbs" divider=">">
    <v-breadcrumbs-item
      slot="item"
      slot-scope="{ item }"
      exact
      :to="item.to"
      :disabled="item.disabled"
    >
      {{ item.text }}
    </v-breadcrumbs-item>
  </v-breadcrumbs>
</template>

<script>
export default {
  name: 'breadcrumbs',
  props: {
    paths: Array
  },
  data: function(){
    return {
      module_id: "61"
    };
  },
  computed: {
    breadcrumbs: function(){
      var new_breadcrumbs = [
        {
          text: this.$i18n.t("message.navigation.home"),
          disabled: false,
          to: "/"
        }
      ];
      if(this.$route.query.referer){
        var referers = this.$route.query.referer.split(":");
        var last_path = this.paths.slice(-1)[0];
        if("nav_path" in this.$parent){
          this.$parent.nav_path = encodeURIComponent(this.$route.query.referer + ":" + last_path);
        }
        var new_referer = "";
        for(var referer of referers){
          if(referer === "" || referer === "/"){
            continue;
          }
          var dirs = referer.split("?")[0].split("/");
          var base_name = dirs.slice(-1)[0];
          if(base_name in this.$i18n.messages.ja.message.navigation){
            new_breadcrumbs.push({
              text: this.$i18n.t("message.navigation." + base_name),
              disabled: false,
              to: referer + (new_referer !== "" ? "?referer=" + encodeURIComponent(new_referer) : "")
            });
          }else{
            new_breadcrumbs.push({
              text: base_name,
              disabled: false,
              to: referer + (new_referer !== "" ? "?referer=" + encodeURIComponent(new_referer) : "")
            });
          }
          if(new_referer === ""){
            new_referer = referer
          }else{
            new_referer += ":" + referer
          }
        }
        var base_name = last_path.split("/").slice(-1)[0];
        if(base_name in this.$i18n.messages.ja.message.navigation){
          new_breadcrumbs.push({
            text: this.$i18n.t("message.navigation." + base_name),
            disabled: true,
            to: last_path
          });
        }else{
          new_breadcrumbs.push({
            text: base_name,
            disabled: true,
            to: last_path
          });
        }
      }else{
        if("nav_path" in this.$parent){
          this.$parent.nav_path = encodeURIComponent(this.paths.join(":"));
        }
        for(var path of this.paths){
          if(path === ""){
            continue;
          }
          var dirs = path.split("?")[0].split("/");
          var base_name = dirs.slice(-1)[0];
          if(base_name in this.$i18n.messages.ja.message.navigation){
            new_breadcrumbs.push({
              text: this.$i18n.t("message.navigation." + base_name),
              disabled: false,
              to: path
            });
          }else{
            new_breadcrumbs.push({
              text: base_name,
              disabled: false,
              to: path
            });
          }
        }
      }
      new_breadcrumbs.slice(-1)[0]["disabled"] = true;
      return new_breadcrumbs;
    }
  }
}
</script>
